module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl3-75.95cbe8d7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl3-75.png
// module id = 3325
// module chunks = 11